<template>
  <div class="section-category section-choosecust">
    <div class="ttl-choosecust col-md-6">
      <h2 class="ttl2 text-uppercase" v-translate>choose customer</h2>
      <div class="form-cut col-md-5">
        <input type="text" class="input-group-field" :placeholder="$gettext('Search')" v-model="searchCust">
      </div>
      <div class="form-cut col-md-2">
        <button class="btn btn-default" @click="removeCustomer" v-translate>remove</button>
      </div>
    </div>
    <grid-view :items="filterCustomers" @pickItem="pickCustomer"></grid-view>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GridView from '@/components/GridView.vue';
import CustomerService from '@/services/CustomerService';
import BillService from '@/services/BillService';

export default {
  name: 'ChooseCust',
  components: {
    GridView,
  },
  data() {
    return {
      searchCust: '',
    };
  },
  computed: {
    filterCustomers() {
      const search = this.searchCust.toLowerCase();
      return this
              .getArray('customers')
              .filter(({ name }) => name.toLowerCase().includes(search))
              .sort((a, b) => a.name.localeCompare(b.name));
    },
    ...mapState({
      bill: state => state.bill.bill,
    }),
    ...mapGetters(['updatedBillItems']),
  },
  methods: {
    pickCustomer(customer) {
      // post this customer to api
      if (this.bill.id !== '') {
        this.bill.customer = customer.id;
        const billData = Object.assign({}, this.bill, { billItems: this.updatedBillItems });
        BillService.post(billData);
      }
      this.$router.push({ name: 'order' });
    },
    async removeCustomer() {
      this.bill.customer = '';
      const billData = Object.assign({}, this.bill, { billItems: this.updatedBillItems });
      await BillService.post(billData);
      this.$router.push({ name: 'order' });
    },
  },
  created() {
    if (!this.bill.id) {
      this.$router.push('order');
    }
  },
};
</script>
